const enum IsaacToastWrapperType {
  OnlyError,
  Full,
}

export default IsaacToastWrapperType;
